import ExcelFileImportModule from "@/modules/ExcelFileImport";

const MasterProductImportPage = () => {
  return <ExcelFileImportModule />;
};

export default MasterProductImportPage;
